import { FC, ReactNode } from 'react';
import { DebugDrawer } from '../components/sandbox/DebugDrawer';

export interface ServiceRequestLayoutProps {
  title: string | ReactNode;
  description?: string | ReactNode;
  macroSlot?: ReactNode;
  leftColumn: ReactNode;
  rightColumn: ReactNode;
}

export const ServiceRequestLayout: FC<ServiceRequestLayoutProps> = ({
  title,
  description,
  macroSlot,
  leftColumn,
  rightColumn
}) => {
  return (
    <>
      <div className="w-full max-w-full mx-auto p-4">
        {!!title && (
          <div className="mb-8">
            {typeof title === 'string' ? (
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            ) : (
              title
            )}
            {description && (
              typeof description === 'string' ? (
                <p className="text-gray-500 mt-2">{description}</p>
              ) : (
                description
              )
            )}
          </div>
        )}

        <div className="flex flex-col lg:flex-row gap-4 items-start max-h-[calc(100vh-120px)]">
          
          {/* Left Column (66%) */}
          <div className="w-full lg:w-2/3 flex flex-col gap-4 lg:gap-6 max-h-[calc(100vh-180px)] overflow-y-auto pr-2 pb-12">
            {macroSlot && (
              <div className="shrink-0">
                {macroSlot}
              </div>
            )}
            {leftColumn}
          </div>
          
          {/* Right Column (33%) */}
          <div className="w-full lg:w-1/3 sticky top-6 pr-6 lg:pr-8 max-h-[calc(100vh-120px)] overflow-y-auto pb-8">
            {rightColumn}
          </div>

        </div>
      </div>
      <DebugDrawer />
    </>
  );
};
